import { action } from '@ember/object';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import Component from '@glimmer/component';

interface ResourceTypeListItemComponentArgs {
  resourceTypeId: number;
  label: string;
  count: number;
  icon: string;
  beta?: boolean;
}

export default class ResourceTypeListItemComponent extends Component<ResourceTypeListItemComponentArgs> {
  @service declare router: RouterService;

  @action
  navigateToResourcePage(): void {
    void this.router.transitionTo(`/resources/${this.args.resourceTypeId}`);
  }

  stopPropagation(e: Event): void {
    e.preventDefault();
    e.stopPropagation();
  }
}
